<template>
<div>
    <v-server-table :name="tableName" :ref="tableName" url="/inspections/list" :columns="columns" :options="options">

        <div slot="afterFilterWrapper" class="ml-md-2 ml-0 mt-md-0 mt-2 mb-md-0 mb-3 float-md-left">
            <div class="clearfix d-md-none d-block"></div>

            <div v-if="allowFilterSaving" class="float-left mr-1">
                <user-filters ref="inspSavedFilters" assetType="Inspection" :filterKey="filterKey" @saving="setUserFilterData" @show="setUserFilterData"></user-filters>
            </div>

            <div class="float-left">
                <table-filters-2 ref="inspTableFilters"
                    filterUrl="/inspections/filters"
                    v-bind:filters="filters"
                    :emptyFilters="filterDefs"
                    :filterKey="filterKey"
                    @filtersChanged="refreshTableData"
                    @filtersCleared="filtersCleared"
                    v-show="!dashboardFilters">
                    <template slot-scope="slotProps">
                        <div class="d-inline-block">
                            <multi-select v-model="slotProps.filters['jobsite.DivisionId']" :btnLabel="(values) => ('Divisions ('+values.length+')')" :selectOptions="slotProps.filterData.divisions" :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <date-range-selector buttonTitle="Inspection Date" v-model="slotProps.filters['inspection.InspectionDate']" />
                        </div>
                        <div class="d-inline-block">
                            <select v-model="slotProps.filters['inspection.SCMM']" class="form-control table-filter">
                                <option value="">-- All SCMM --</option>
                                <option value="yes">SCMM Completed</option>
                                <option value="no">SCMM Not Completed</option>
                            </select>
                        </div>
                        <div class="d-inline-block" style="width: 250px;">
                            <jobsite-select
                                :forFilters="true"
                                :selectedValues="slotProps.filters['inspection.JobsiteId']"
                                v-on:vselected="((data) => { slotProps.filters['inspection.JobsiteId'] = data || {};  })" />
                        </div>
                        <div class="d-inline-block">
                            <multi-select
                                v-model="slotProps.filters['inspection.inspection_form_id']"
                                :btnLabel="(values) => ('Forms ('+values.length+')')"
                                :selectOptions="slotProps.filterData.forms"
                                :options="{multi: true}"></multi-select>
                        </div>
                        <div class="d-inline-block">
                            <multi-select
                                v-model="slotProps.filters['inspection.status_id']"
                                :btnLabel="(values) => ('Statuses ('+values.length+')')"
                                :selectOptions="slotProps.filterData.statuses"
                                :options="{multi: true}" />
                        </div>
                        <hr/>

                        <div class="d-inline-block" style="width: 250px;">
                            <user-select
                                :forFilters="true"
                                :selectedValues="slotProps.filters['inspection.CreatedByUserId']"
                                v-on:vuselected="((data) => { slotProps.filters['inspection.CreatedByUserId'] = data || {};  })"
                                placeholder="Created By User"
                                :appendCurrentUserOption="true" />
                        </div>
                        <template v-if="$store.state.user.enable_public_insp_forms">
                            <div class="d-inline-block">
                                OR
                            </div>
                            <div class="d-inline-block" style="width: 250px;">
                                <employee-select
                                    :forFilters="true"
                                    :selectedValues="slotProps.filters['inspection.CreatedByEmployeeId']"
                                    v-on:vselected="((data) => { slotProps.filters['inspection.CreatedByEmployeeId'] = data || {}; })"
                                    placeholder="Created By Employee" />
                            </div>
                            <div class="d-inline-block ml-2">
                                <i class="fa fa-question-circle text-info" title="The 'Created By Employee' filter can be used for Public Forms submitted via QR Code. This uses OR logic with the 'Created By User' filter"></i>
                            </div>
                        </template>
                        <hr/>

                        <div class="form-inline">
                            <div class="form-group mr-2">
                                <label class="mr-1">Is Equipment Inspection:</label>
                                <b-form-select v-model="slotProps.filters['inspection.has_equipment_id']" size="sm" :options="[{value: null, text: '-- Show All--'}, {value: 0, text: 'No'}, {value: 1, text: 'Yes'}]"></b-form-select>
                            </div>
                            <div class="form-group mr-2">
                                <multi-select
                                    v-model="slotProps.filters['equipment.equipment_type_id']"
                                    :btnLabel="(values) => ('Equipment Types ('+values.length+')')"
                                    :selectOptions="slotProps.filterData.equipment_types"
                                    :options="{multi: true}" />
                            </div>
                            <div class="form-group mr-2" style="width: : 300px;">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-light">Score</span>

                                        <select class="form-control" v-model="slotProps.filters['inspection_score'].logic">
                                            <option value=">">></option>
                                            <option value=">=">>=</option>
                                            <option value="=">=</option>
                                            <option value="<"><</option>
                                            <option value="<="><=</option>
                                        </select>
                                      </div>
                                    <input type="number" class="form-control" min="0" max="100" placeholder="Enter an Inspection Score" v-model="slotProps.filters['inspection_score'].value">
                                    <div class="input-group-append">
                                        <span class="input-group-text bg-light">%</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>
                </table-filters-2>
            </div>

            <button type="button" class="btn btn-outline-success ml-2" v-on:click="exportTable()" :disabled="exportingTable" v-if="false">
                <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
            </button>

            <b-dropdown variant="outline-success" class="ml-2">
                <template #button-content>
                    <template v-if="!exportingTable"><i class="fa fa-file-excel-o"></i> Export</template>
                    <template v-else><i class="fa fa-circle-o-notch fa-spin"></i> Exporting</template>
                </template>
                <b-dropdown-item href="javascript:void(0)" v-on:click="exportTable()">Export Without Employee Custom Fields</b-dropdown-item>
                <b-dropdown-item href="javascript:void(0)" v-on:click="exportTable(true)">Export With Employee Custom Fields</b-dropdown-item>
            </b-dropdown>

            <router-link :to="addBtnUrl" v-if="addBtnShow && addBtnUrl" class="btn btn-outline-info ml-2">
                <span v-html="addBtnText"></span>
            </router-link>

            <div class="clearfix d-md-none d-block"></div>
        </div>

        <router-link slot="InspectionId" slot-scope="props" :to="`/inspections/view/${props.row.InspectionId}`" title="View Inspection" class="btn btn-sm btn-light">
            View
        </router-link>

        <template slot="InspectionDate" slot-scope="props">
            <router-link :to="`/inspections/view/${props.row.InspectionId}`" title="View Inspection">{{ props.row.InspectionDate | moment("MM/DD/YYYY") }}</router-link>
        </template>

        <template slot="status_name" slot-scope="props">
            <label :class="`badge badge-${props.row.status_color}`">{{ props.row.status_name }}</label>
        </template>

        <template slot="super_last_name" slot-scope="props">
            <template v-if="props.row.superintendent_id">
                {{ props.row.super_first_name }} {{ props.row.super_last_name }}
            </template>
        </template>

        <router-link slot="JobsiteName" slot-scope="props" :to="`/jobsites/view/${props.row.JobsiteId}`" title="View Jobiste">
            {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
        </router-link>

        <template slot="scmm_date" slot-scope="props">
            <span v-if="props.row.scmm_date">{{ props.row.scmm_date | moment("MM/DD/YYYY") }}</span>
            <span v-else>--</span>
        </template>

        <template slot="inspection_equipment_id" slot-scope="props">
            <router-link :to="`/equipment/view/${props.row.inspection_equipment_id}`" title="View Inspection" v-if="props.row.inspection_equipment_id">
                {{ props.row.equipment_type_name }} <span v-if="props.row.model_number">- {{ props.row.model_number }}</span> <span v-if="props.row.serial_number">- {{ props.row.serial_number }}</span><span v-if="props.row.equipment_name">- {{ props.row.equipment_name }}</span>
            </router-link>
        </template>

        <template slot="owner_last_name" slot-scope="props">
            <template v-if="props.row.hide_creator == 0 || $store.state.user.is_admin == true">
                {{ props.row.owner_first_name }} {{ props.row.owner_last_name }}  <template v-if="props.row.owner_employee_number"> - {{ props.row.owner_employee_number }}</template>
            </template>
        </template>

        <template slot="created_at" slot-scope="props">
            {{ props.row.created_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}
        </template>

        <router-link slot="form_name" slot-scope="props" :to="`/inspections/forms/view/${props.row.inspection_form_id}`" title="View Inspection Form">
            {{ props.row.form_name }}
        </router-link>

        <template slot="child_row" slot-scope="props">
            <div>
                <label class="text-muted">Total Elements Compliant:</label> {{ props.row.TotalCompliant }}
            </div>
            <div>
                <label class="text-muted">Total Elements NonCompliant:</label> {{ (props.row.TotalInspected - props.row.TotalCompliant) }}
            </div>
            <div>
                <label class="text-muted">Total Elements Inspected:</label> {{ props.row.TotalInspected }}
            </div>

            <custom-field-table-display :custom_fields="props.row.custom_fields"></custom-field-table-display>
        </template>
    </v-server-table>
</div>
</template>

<script>
    import filterExtractor from '@/helpers/TableFilterExtractor';
    import customVTColDropdown from '@/components/vue-tables-2/CustomColumnDropdown';

    export default {
        props: {
            assetType: {
                type: String,
                default: null,
            },

            assetId: {
                //type: Number,
                default: null,
            },

            allowFilterSaving: {
                //type: Boolean,
                default: false,
            },

            addBtnShow: {
                type: Boolean,
                default: false,
            },

            addBtnUrl: {
                type: String,
                default: null,
            },

            addBtnText: {
                type: String,
                default: '<i class="fa fa-plus"></i> Add',
            },

            filterId: {
                type: Number,
                default: null,
            },

            dashboardFilters: {
                type: Object,
                default(){
                    return null;
                },
            },

            tableConfig: {
                type: Object,
                default(){
                    return null;
                },
            },
        },

        data() {
            return {
                userTimezone: this.$store.state.user.timezone,
                exportingTable: false,
                tableName: "inspectionTable",

                columns: [
                    'InspectionId',
                    'InspectionDate',
                    'DivisionName',
                    'JobsiteName',
                    'status_name',
                    'super_last_name',
                    'NumberOfEmployees',
                    'GeneralContractor',
                    'Score',
                    'inspection_equipment_id',
                    'scmm_date',
                    'owner_last_name',
                    'created_at',
                    'form_name',
                ],

                filterDefs: {
                    'jobsite.DivisionId': [],
                    'inspection.InspectionDate' : '',
                    'inspection.SCMM' : '',
                    'inspection.JobsiteId' : {},
                    'inspection.inspection_form_id': [],
                    'inspection.status_id': [],
                    'inspection.CreatedByUserId': {},
                    'inspection.CreatedByEmployeeId': {},
                    'equipment.equipment_type_id': [],
                    //'inspection.score_logic': '>',
                    'inspection_score': {
                        'value': null,
                        'logic': '>'
                    },
                    'inspection.has_equipment_id': null,
                },

                filterKey: 'inspectionFilters',
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            filters(){
                //Check State
                if(this.$store.state.tableFilters.filters[this.filterKey])
                {
                    //Send it
                    return this.$store.state.tableFilters.filters[this.filterKey];
                }

                //Return Definition
                return JSON.parse(JSON.stringify(this.filterDefs));
            },

            appliedFilter(){
                //Send it
                return this.$store.state.appliedFilters[this.filterKey] ? this.$store.state.appliedFilters[this.filterKey] : null;
            },

            options(){
                return {
                    headings: {
                        InspectionId: 'ID',
                        InspectionDate: 'Date',
                        DivisionName: 'Division',
                        JobsiteName: 'Jobsite',
                        status_name: 'Status',
                        super_last_name: 'Superintendent',
                        NumberOfEmployees: '# Employees',
                        GeneralContractor: 'Gen. Contractor',
                        Score: 'Score',
                        inspection_equipment_id: 'Equpiment',
                        scmm_date: 'SCMM',
                        owner_last_name: 'Creator',
                        created_at: 'Created',
                        form_name: 'Form',
                    },
                    templates: {
                        Score: 'inspection-score',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'inspection.InspectionDate',
                    },
                    saveState: this.allowFilterSaving,
                    columnsDropdown: customVTColDropdown,
                    visibleColumns: (this.allowFilterSaving ? this.$root.getVisibleColumnsFromState(this.tableName) : false),

                    sendInitialRequest: (this.filterId ? false : true),

                    responseAdapter: (response) => {
                        //Emit the count
                        this.$emit('inspectionListCount', response.data.count);

                        //Send it
                        return response.data;
                    },

                    requestAdapter: (data) => {
                        //Set the filters
                        data.filters = (this.dashboardFilters ? filterExtractor.extractFilters(this.dashboardFilters) : filterExtractor.extractFilters(this.filters));

                        //Include the asset
                        data.assetType = this.assetType;
                        data.assetId = this.assetId;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'InspectionId',
                };
            },
        },

        methods: {

            refreshTableData(filters) {
                //Set the data
                this.$refs.inspectionTable.setPage(1);
                //this.$refs.inspectionTable.getData();
            },

            filtersCleared(){
                //Reset
                this.refreshTableData();

                //Reset the Columns
                this.$refs.inspTableFilters.resetColVis(this.$refs.inspectionTable);
            },

            setUserFilterData(){
                //Call the Helper
                this.$refs.inspSavedFilters.setFilterParams(this.$refs.inspectionTable);
            },

            checkForAppliedFilter(){
                //Check if
                if(!this.allowFilterSaving || !this.appliedFilter)
                {
                    return;
                }

                //Call the helper
                this.$refs.inspTableFilters.setColVis(this.$refs.inspectionTable);
            },

            exportTable(with_custom_fields = false){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                //var cols = JSON.parse(JSON.stringify(this.$refs.inspectionTable.columns));

                //Build the payload
                var payload = {
                    filters: filters,
                    query: (this.$refs.inspectionTable.getRequestParams()).query,
                    orderBy: this.$refs.inspectionTable.options.orderBy.column,
                    ascending: this.$refs.inspectionTable.options.orderBy.ascending,
                    table: 'inspTable',
                    columns: this.$refs.inspectionTable.columns,
                    visible_columns: this.$root.getVisibleColumnsFromState(this.tableName),
                    export: true,
                    assetType: this.assetType,
                    assetId: this.assetId,
                    load_custom_fields: with_custom_fields,
                    custom_field_type: 'Employee',
                    //headings: this.$refs.inspectionTable.options.headings,
                };

                //Send it
                this.$http.get('/inspections/list', payload)
                    .then(response => {
                        //Open the new window
                        //window.open(response.data);

                        //Alert the User
                        this.$toastr.success(response.data);
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.error(err.response.data, 'Failed to Export Inspections');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted(){
            //Check for Staring Filters
            if(!this.dashboardFilters)
            {
                //Set it
                //this.$refs.inspTableFilters.setFilters(this.dashboardFilters);

                //Check for a saved filter
                this.checkForAppliedFilter();

                //Check for Filter ID
                if(this.filterId)
                {
                    this.$refs.inspSavedFilters.setSavedFilter(this.filterId);
                }
            }

            //Check for Table Config
            if(this.tableConfig)
            {
                //Set it
                this.$refs.inspTableFilters.setColVisFromSavedFilter(this.$refs.inspectionTable, this.tableConfig);
            }
        }
    }
</script>
